// extracted by mini-css-extract-plugin
export default {"fill":"ChannelAvatarContent_fill__h2RlA","avatarIcon":"ChannelAvatarContent_avatarIcon__9llHo"};